import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=3a2c5137&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2c5137",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2c5137')) {
      api.createRecord('3a2c5137', component.options)
    } else {
      api.reload('3a2c5137', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=3a2c5137&scoped=true&", function () {
      api.rerender('3a2c5137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-201V27iL26AVU/JS/comp/Voucher-Unit.vue"
export default component.exports